import * as React from "react";
import {createRoot} from "react-dom/client";
import EnergyLabel from "./EnergyLabel";

export class EnergyLabelPortal {
  public static run(elements: NodeListOf<HTMLElement> | HTMLElement[]): void {
    elements.forEach((element: HTMLElement) => {
      const energyClass = element.dataset.energyClass;
      const energyMediaUrl = element.dataset.energyMedia;

      const priceSpan = element.querySelector<HTMLSpanElement>(".price-value");
      const hasDataFromProductDetails = element.className.includes("product-details");
      const energyLabelDiv = document.createElement("div");

      if (priceSpan && energyClass) {
        if (!hasDataFromProductDetails) {
          priceSpan.style.verticalAlign = "middle";
        }
        priceSpan.parentNode?.insertBefore(energyLabelDiv, priceSpan);

        const root = createRoot(energyLabelDiv);
        root.render(
          <EnergyLabel
            energyClass={energyClass}
            media={energyMediaUrl}
            size={hasDataFromProductDetails ? "big" : "small"}
          />,
        );
        energyLabelDiv.style.display = "inline-block";
        energyLabelDiv.style.verticalAlign = "middle";
      }
    });
  }
}

export default EnergyLabelPortal;
